import { gql } from 'graphql-request'

export const analyticsV2QueryMeasureQuery = gql`
  query AnalyticsV2QueryMeasure($input: AnalyticsV2QueryMeasureInput!) {
    analyticsV2QueryMeasure(input: $input) {
      rows
      totalRows
      queryDurationMs
      trustTier
      transparency {
        measureUsed
        dimensionsUsed
        scopeApplied
        timeRange
        dataFreshness
      }
    }
  }
`
